import React from 'react';

import NrgComponent from './../../NrgComponent.jsx';
import { Content } from './Content.js';
import SideEnd from './SideEnd.jsx';
import SideNavigation from './SideNavigation.jsx';

export default class VideoBox extends NrgComponent {

  render() {
    const leftNav = this.getNav('left', this.props.page);
    const rightNav = this.getNav('right', this.props.page);
    const poster = Content[this.props.page].video.jpg;
    const webm = Content[this.props.page].video.webm;
    const mp4 = Content[this.props.page].video.mp4;
    const video = this.getVideoHtml(poster, webm, mp4);

    return (
      <div className="VideoBox col-xs-16">
        <div className="video-wrapper" dangerouslySetInnerHTML={ { __html: video } }>
        </div>
        <div className="video-content-wrapper">
          <div className="inner">
            <span className="number">{Content[this.props.page].number}</span>
            <div className="middle-content">
              {leftNav}
              <h1>{Content[this.props.page].title}</h1>
              {rightNav}
            </div>
          </div>
        </div>
      </div>
    );
  }

  getVideoHtml(poster, webm, mp4) {
    return (
      `<video muted loop preload="auto" style="background-image:url(${poster})" playsinline="true" webkit-playsinline="true" autoplay="true">
        <source src="${webm}" type="video/webm"/>
        <source src="${mp4}" type="video/mp4"/>
      </video>
      <div class="dot-matrix-container">
        <div class="dot-matrix"></div>
      </div>`
    );
  }

  getNav(direction, currentPage) {
    if (direction === 'left' && currentPage === 'homepage') {
      return (
        <SideEnd direction="left" />
      );
    }

    if (direction === 'right' && currentPage === 'news') {
      return (
        <SideEnd direction="right" />
      );
    }

    const page = (direction === 'left')
      ? this.getPreviousPageSlug(currentPage)
      : this.getNextPageSlug(currentPage)
    ;

    return (
        <SideNavigation targetPage={page} direction={direction} />
    );
  }
};
